import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { withRouteAccessCheck } from "../../../../../app/Hoc/WithLoginAceessCheck.js";
import {
  deleteSubscriber,
  createSubscriber,
} from "../../../../../app/redux/slices/app/manageFiberServiceSlice.js";
import ConfirmationDialog from "../../../../components/customComponents/ConfirmationModal/index";
import CustomSnackbar from "../../../../components/customComponents/CustomSnackbar/index";
import { validateForm } from "../../../../components/customComponents/customValidation/index";
import {
  getPremiseDetails,
  getCaseAndOrderDetails,
  fetchONTdetailsBySlNumber,
  updatePremiseServicePointDetails,
  updateOrderDetails,
  updateCaseDetails,
  getSmxOrderItemDetails,
  getSmxTemplateMetadata,
} from "../../../../../app/redux/slices/app/fiberEnrollmentIssueSlice.js";
import { CircularProgress } from "@mui/material";
import { searchPremisesByTerm } from "../../../../../app/redux/slices/app/premiseSlice";
import dayjs from "dayjs";
import { el } from "date-fns/locale";

const FiberEnrollmentIssue = () => {
  const [inputValue, setInputValue] = React.useState(""); // Add state for input value
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [showMessage, setShowMessage] = useState("");
  const [searchedAddreess, setSearchedAdrr] = useState([]);
  const [searchLoader, setSearchLoader] = useState(false);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const [errorMessages, setErrorMessages] = useState({});

  // Confirmation dialogs state
  const [confirmationDialogs, setConfirmationDialogs] = useState({
    addressMismatch: false,
    deleteSubscriber: false,
  });

  // Task tracking state
  const [taskList, setTaskList] = useState([]);
  const [showTaskProgress, setShowTaskProgress] = useState(false);

  const initState = {
    address: "",
    location: "",
    city: "",
    community_name: "",
    crm_premise_id: "",
    state: "",
    zip: "",
    premDetails: {
      closeCase: false,
      caseNumber: "",
      deleteSubscriber: false,
      deleteONT: false,
      ontIdToDelete: "",
      oltIdToDelete: "",
      smxSubscriberToDelete: "",
      calixSubscriberIdToDelete: "",
      calixSubscriberServiceIdToDelete: "",
      resumeEnrollmentFlow: false,
      preProvisioning: false,
      orderNumber: "",
      subscriberId: "",
      calixSubscriberId: "",
      calixSubscriberServiceId: "",
      premise_name: "",
      customer_type: "",
      jurisdiction: "",
      street_address: "",
      city: "",
      state: "",
      country: "",
      region: "",
      zone: "",
      service_type: null,
      premise_district: "",
      premise_market: "",
      ont_template: null,
      installation_type: null,
      mesh_unit_install_date: null,
      meter_number: null,
      meter_status: null,
      rg_fsan: null,
      ont_fsan: null,
      ont_port_id: "G1",
      ont_profile_id: "",
      ont_id: null,
      ont_type: "Global",
      service_status: true,
      service_reference_number: "",
      create_new_ont: true,
      app_service_name: "ProtectIQ",
      olt_id: "virtualOLT",
      vlan_id: "2001",
      community_name: "",
      crm_premise_id: "",
      serach_term: "",
      zip: "",
      type: "",
      service_point_id: "",
      fiber_service: {
        active: false,
        active_users: null,
        available: false,
        meter_disconnected: false,
        pre_installed: false,
        selected: false,
      },
      smxProvisioning: {
        fetchDetails: false,
        selected: false,
        "app-services": [
          {
            "app-service": {
              "app-service-name": "ProtectIQ",
            },
          },
        ],
        "device-data": {
          "create-new-ont": true,
          ont: {
            "olt-id": "virtualOLT",
            "ont-fsan-number": "",
            "ont-id": "",
            "ont-port-id": "G1",
            "ont-profile-id": "",
            "ont-type": "Global",
            "vlan-id": 2001,
          },
          router: {
            "router-fsan-number": "",
          },
        },
        location: "",
        region: "",
        "max-internet-speed-in-mbps": "",
        service: {
          "policy-map": "RES_1G_IP",
          "service-code": "C-FIB-1G",
          "service-status": "enabled",
          "service-template": "RES_DATA_IP_RG",
          "service-type-code": "DATA_SERVICE",
        },
        "service-address": {
          "address-line1": "",
          "address-line2": "",
          "city-name": "",
          "country-code": "US",
          "postal-code": "",
          "state-code": "",
        },
        "service-reference-number": "",
        "service-start-date": "", //"11-12-2025",
        subscriber: {
          "billing-address": {
            "address-line1": "",
            "address-line2": "",
            "city-name": "",
            "country-code": "US",
            "postal-code": "",
            "state-code": "",
          },
          "business-name": "Pre-Provisioning",
          "customer-type-code": "Residential",
          "email-id": "provisioning@pre.com",
          "first-name": "Pre",
          "last-name": "Provisioning",
          "opt-out-of-marketing": true,
          "phone-number": "9999999999",
          "preferred-language-code": "en_US",
        },
      },
    },
  };

  const [formData, setFormData] = useState(initState);

  const validationRules = {
    app_service_name: {
      required: true,
      name: "App service name",
      minDigits: "3",
    },
    caseNumber: {
      required: formData?.premDetails?.closeCase === true,
      name: "Case Number",
      minDigits: "3",
    },
    orderNumber: {
      required: formData?.premDetails?.resumeEnrollmentFlow === true,
      name: "Order Number",
      minDigits: "3",
    },
    olt_id: {
      required: true,
      name: "OLT ID",
      minDigits: "3",
    },
    ont_fsan: {
      required: true,
      name: "ONT FSAN",
      minDigits: "3",
    },
    ont_id: {
      required: true,
      name: "ONT ID",
      minDigits: "3",
    },
    ont_port_id: {
      required: true,
      name: "ONT Port ID",
      minDigits: "2",
    },
    ont_profile_id: {
      required: true,
      name: "ONT Profile ID",
      minDigits: "3",
    },
    ont_type: {
      required: true,
      name: "ONT Type",
      minDigits: "3",
    },
    rg_fsan: {
      required: true,
      name: "Router FSAN",
      minDigits: "3",
    },
    service_status: {
      required: true,
      name: "Service Status",
      minDigits: "3",
    },
    subscriberId: {
      required: true,
      name: "Subscriber ID",
      minDigits: "2",
    },
    vlan_id: {
      required: true,
      name: "VLAN ID",
      minDigits: "3",
    },
    smxSubscriberToDelete: {
      required:
        formData?.premDetails?.deleteSubscriber === true ||
        formData?.premDetails?.deleteONT,
      name: "SMX Subscriber ID To Delete",
      minDigits: "2",
    },
    ontIdToDelete: {
      required: formData?.premDetails?.deleteONT,
      name: "ONT ID To Delete",
      minDigits: "2",
    },
    oltIdToDelete: {
      required: formData?.premDetails?.deleteONT,
      name: "OLT ID To Delete",
      minDigits: "2",
    },
    "smxProvisioning.service.policy-map": {
      required: formData?.premDetails?.smxProvisioning.selected,
      name: "Policy Map (eg: RES_2G_IP)",
      minDigits: "2",
    },
    "smxProvisioning.service.service-code": {
      required: formData?.premDetails?.smxProvisioning.selected,
      name: "Service Code (eg: C-FIB-1G)",
      minDigits: "2",
    },
    "smxProvisioning.service.service-template": {
      required: formData?.premDetails?.smxProvisioning.selected,
      name: "Service Template (eg: RES_DATA_IP_RG)",
      minDigits: "2",
    },
    "smxProvisioning.service-start-date": {
      required: formData?.premDetails?.smxProvisioning.selected,
      name: "Service Start Date",
      minDigits: "2",
    },
    "smxProvisioning.subscriber.business-name": {
      required: formData?.premDetails?.smxProvisioning.selected,
      name: "Business Name",
      minDigits: "2",
    },
    "smxProvisioning.subscriber.customer-type-code": {
      required: formData?.premDetails?.smxProvisioning.selected,
      name: "Customer Type Code (eg: Residential)",
      minDigits: "2",
    },
    "smxProvisioning.subscriber.first-name": {
      required: formData?.premDetails?.smxProvisioning.selected,
      name: "First Name",
      minDigits: "2",
    },
    "smxProvisioning.subscriber.last-name": {
      required: formData?.premDetails?.smxProvisioning.selected,
      name: "Last Name",
      minDigits: "2",
    },
    "smxProvisioning.subscriber.email-id": {
      required: formData?.premDetails?.smxProvisioning.selected,
      name: "Email ID",
      minDigits: "5",
      pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      patternMessage: "Please enter a valid email address",
    },
    "smxProvisioning.subscriber.phone-number": {
      required: formData?.premDetails?.smxProvisioning.selected,
      name: "Phone Number",
      minDigits: "10",
      pattern: /^[\d\s\-\(\)\+]+$/,
      patternMessage: "Please enter a valid phone number",
    },
    "smxProvisioning.subscriber.billing-address.address-line1": {
      required: formData?.premDetails?.smxProvisioning.selected,
      name: "Billing Address Line 1",
      minDigits: "2",
    },
    "smxProvisioning.subscriber.billing-address.city-name": {
      required: formData?.premDetails?.smxProvisioning.selected,
      name: "Billing City Name",
      minDigits: "2",
    },
    "smxProvisioning.subscriber.billing-address.state-code": {
      required: formData?.premDetails?.smxProvisioning.selected,
      name: "Billing State Code (eg: CA)",
      minDigits: "2",
    },
    "smxProvisioning.subscriber.billing-address.postal-code": {
      required: formData?.premDetails?.smxProvisioning.selected,
      name: "Billing Postal Code",
      minDigits: "5",
      pattern: /^\d{5}(-\d{4})?$/,
      patternMessage:
        "Please enter a valid postal code (eg: 12345 or 12345-6789)",
    },
  };

  // Update address search
  const updateAddress = (e) => {
    if (e.target.value.length > 2) {
      setSearchLoader(true);
      setFormData({ ...initState, address: e.target.value });
      setShowTaskProgress(false);
      setTaskList([]);

      dispatch(searchPremisesByTerm(e?.target?.value)).then((resp) => {
        setSearchLoader(false);
        if (resp?.payload?.data?.data?.length > 0) {
          setSearchedAdrr(resp?.payload?.data?.data);
          setSearchLoader(false);
        }
      });
    }
  };

  function formatErrorMessage(message) {
    try {
      const responseData = JSON.parse(message);
      let dataArray = [];

      // Check if data is an array (first JSON structure)
      if (Array.isArray(responseData.data)) {
        dataArray = responseData.data;
      }
      // Check if data is an object with api-responses (second JSON structure)
      else if (responseData.data?.["api-responses"]) {
        dataArray = responseData.data["api-responses"];
      }
      // If data itself is empty or invalid
      else {
        return message;
      }

      if (dataArray.length === 0) {
        return message;
      }

      if (!responseData?.data || responseData.data.length === 0) {
        return message;
      }

      return dataArray
        .map((item) => {
          const status = item.response["is-success"] ? "Success" : "Failed";
          const code = item.response["response-code"];
          const reason = (item.response.messages || [])
            .map((msg) => msg.replace(/^[A-Z]+\.\d+,\s*/, "").trim())
            .join(". ");

          return `${item["api-name"]} → ${status} (${code})${
            reason ? `: ${reason}` : ""
          }`;
        })
        .join("\n");
    } catch {
      return message;
    }
  }

  // Load premise data
  const LoadGridData = async () => {
    setFormData((prev) => ({
      ...initState,
      crm_premise_id: prev.crm_premise_id,
      address: prev.address,
      premiseCalling: true,
    }));
    setTaskList([]);
    setErrorMessages({});

    try {
      // Execute getPremiseDetails and getCaseAndOrderDetails in parallel
      const [premDetailsResponse, caseAndOrderResponse] = await Promise.all([
        dispatch(getPremiseDetails(formData.crm_premise_id)),
        dispatch(getCaseAndOrderDetails(formData.crm_premise_id)),
      ]);

      // Handle premise details
      if (premDetailsResponse?.payload?.data?.["is-success"]) {
        const data = premDetailsResponse.payload.data.data;

        setFormData((prev) => ({
          ...prev,
          premDetails: {
            ...prev.premDetails,
            ...data,
            subscriberId:
              data.service_reference_number ?? data.service_point_id,
            calixSubscriberId: data.subscriber_id,
            calixSubscriberServiceId: data.subscriber_service_id,
            ont_type: data.ont_type ?? initState.premDetails.ont_type,
            service_status:
              data.service_status ?? initState.premDetails.service_status,
            create_new_ont:
              data.create_new_ont ?? initState.premDetails.create_new_ont,
            app_service_name:
              data.app_service_name ?? initState.premDetails.app_service_name,
            olt_id: data.olt_id ?? initState.premDetails.olt_id,
            vlan_id: data.vlan_id ?? initState.premDetails.vlan_id,
            oltIdToDelete: data.olt_id ?? initState.premDetails.olt_id,
            ontIdToDelete: data.ont_id,
          },
        }));

        showNotification("Premise details fetched successfully", "success");

        // Fetch ONT details (dependent on premise details)
        await fetchONTdetails(data.ont_fsan);
      } else {
        showNotification("Failed to fetch premise details", "error");
      }

      // Handle case and order details
      if (caseAndOrderResponse?.payload?.data?.["is-success"]) {
        const data = caseAndOrderResponse.payload.data.data;

        setFormData((prev) => ({
          ...prev,
          premDetails: {
            ...prev.premDetails,
            caseNumber: data.case_no,
            orderNumber: data.order_no,
          },
        }));

        showNotification("Order details fetched successfully", "success");
      } else {
        showNotification("Failed to fetch order details", "error");
      }
    } catch (error) {
      showNotification("An error occurred while fetching data", "error");
      console.error("LoadGridData error:", error);
    } finally {
      // Always unset the loading flag after all operations complete
      setFormData((prev) => ({ ...prev, premiseCalling: false }));
    }
  };

  // Fetch ONT details
  const fetchONTdetails = async (ont_fsan) => {
    if (!ont_fsan) return;

    const premONTDetails = await dispatch(fetchONTdetailsBySlNumber(ont_fsan));

    if (premONTDetails?.payload?.data?.["is-success"]) {
      setFormData((prev) => ({
        ...prev,
        premONTDetails: premONTDetails?.payload?.data?.data,
        premDetails: {
          ...prev.premDetails,
          smxSubscriberToDelete:
            premONTDetails?.payload?.data?.data?.["subscriber-id"],
          calixSubscriberIdToDelete:
            premONTDetails?.payload?.data?.data?.["calix-subscriber-id"],
          calixSubscriberServiceIdToDelete:
            premONTDetails?.payload?.data?.data?.[
              "calix-subscriber-service-id"
            ],
        },
        location: premONTDetails?.payload?.data?.data?.ontdescription,
      }));

      showNotification("ONT details fetched successfully", "success");
    } else {
      showNotification(`ONT(${ont_fsan}) details not found in SMX`, "error");
    }
  };

  // Show notification helper
  const showNotification = (message, severity = "success") => {
    setShowMessage(message);
    setOpenSnackbar(true);
  };

  // Validate address match
  const validateAddressMatch = () => {
    const isSameFirst10 =
      formData.address.substring(0, 10).trim().toLowerCase() ===
      formData.location.substring(0, 10).trim().toLowerCase();

    return isSameFirst10;
  };

  // Build task list based on form selections
  const buildTaskList = () => {
    const tasks = [
      {
        id: "update_service_point",
        name: "Update Service Point Details",
        status: "pending",
        required: true,
        message: "",
      },
    ];

    if (
      formData?.premDetails?.deleteSubscriber ||
      formData?.premDetails?.deleteONT
    ) {
      tasks.push({
        id: "delete_subscriber",
        name: `${
          formData?.premDetails?.deleteSubscriber
            ? "Delete Existing Subscriber. "
            : ""
        } ${formData?.premDetails?.deleteONT ? "Delete ONT. " : ""}`,
        status: "pending",
        required: true,
        message: "",
      });
    }

    if (formData?.premDetails?.closeCase) {
      tasks.push({
        id: "close_case",
        name: "Close Case",
        status: "pending",
        required: true,
        message: "",
      });
    }

    if (
      formData?.premDetails?.resumeEnrollmentFlow &&
      !formData?.premDetails.smxProvisioning.selected
    ) {
      tasks.push({
        id: "update_order_false",
        name: "Update Order Details (Uncheck flag)",
        status: "pending",
        required: true,
        message: "",
      });

      tasks.push({
        id: "update_order_true",
        name: "Update Order Details (Check flag)",
        status: "pending",
        required: true,
        message: "",
      });
    }

    if (formData?.premDetails?.smxProvisioning?.selected) {
      tasks.push({
        id: "new_provisioning",
        name: "SMX Provisioning",
        status: "pending",
        required: true,
        message: "",
      });

      tasks.push({
        id: "update_service_point_again",
        name: "Update Service Point With New SMX Details",
        status: "pending",
        required: true,
        message: "",
      });
    }

    return tasks;
  };

  // Update task status
  const updateTaskStatus = (taskId, status, message) => {
    setTaskList((prevTasks) =>
      prevTasks.map((task) =>
        task.id === taskId ? { ...task, status, message } : task,
      ),
    );
  };

  const executeServicePointUpdateAgain = async (newProvisioningResult) => {
    updateTaskStatus("update_service_point_again", "processing");

    const payload = {
      service_point_id: formData?.premDetails?.service_point_id,
      fsan: formData?.premDetails?.rg_fsan,
      ont_fsan: formData?.premDetails?.ont_fsan,
      ont_port_id: formData?.premDetails?.ont_port_id,
      ont_profile_id: formData?.premDetails?.ont_profile_id,
      ont_id: formData?.premDetails?.ont_id,
      ont_type: formData?.premDetails?.ont_type,
      service_status: formData?.premDetails?.service_status,
      service_reference_number: formData?.premDetails?.subscriberId,
      subscriber_service_id:
        newProvisioningResult.subscriberServiceId ??
        formData?.premDetails?.calixSubscriberServiceId,
      subscriber_id:
        newProvisioningResult.subscriberId ??
        formData?.premDetails?.calixSubscriberId,
      create_new_ont: formData?.premDetails?.create_new_ont || false,
      app_service_name: formData?.premDetails?.app_service_name,
      olt_id: formData?.premDetails?.olt_id,
      vlan_id: formData?.premDetails?.vlan_id,
    };

    const res = await dispatch(updatePremiseServicePointDetails(payload));

    if (res?.payload?.data?.["is-success"]) {
      updateTaskStatus("update_service_point_again", "completed");
      return { success: true, message: "Service point updated successfully" };
    } else {
      let message = "";
      if (res?.payload?.data?.["messages"]) {
        message += res?.payload?.data?.["messages"].join(", ");
      }
      updateTaskStatus("update_service_point_again", "failed", message);
      return { success: false, message: "Failed to update service point." };
    }
  };

  const executeServicePointUpdate = async () => {
    updateTaskStatus("update_service_point", "processing");

    const payload = {
      service_point_id: formData?.premDetails?.service_point_id,
      fsan: formData?.premDetails?.rg_fsan,
      ont_fsan: formData?.premDetails?.ont_fsan,
      ont_port_id: formData?.premDetails?.ont_port_id,
      ont_profile_id: formData?.premDetails?.ont_profile_id,
      ont_id: formData?.premDetails?.ont_id,
      ont_type: formData?.premDetails?.ont_type,
      service_status: formData?.premDetails?.service_status,
      service_reference_number: formData?.premDetails?.subscriberId,
      create_new_ont: formData?.premDetails?.create_new_ont || false,
      app_service_name: formData?.premDetails?.app_service_name,
      olt_id: formData?.premDetails?.olt_id,
      vlan_id: formData?.premDetails?.vlan_id,
      subscriber_service_id: formData?.premDetails?.calixSubscriberServiceId,
      subscriber_id: formData?.premDetails?.calixSubscriberId,
    };

    const res = await dispatch(updatePremiseServicePointDetails(payload));

    if (res?.payload?.data?.["is-success"]) {
      updateTaskStatus("update_service_point", "completed");
      return { success: true, message: "Service point updated successfully" };
    } else {
      let message = "";
      if (res?.payload?.data?.["messages"]) {
        message += res?.payload?.data?.["messages"].join(", ");
      }
      updateTaskStatus("update_service_point", "failed", message);
      return { success: false, message: "Failed to update service point." };
    }
  };

  const executeSubscriberDeletion = async () => {
    updateTaskStatus("delete_subscriber", "processing");

    const res = await dispatch(
      deleteSubscriber({
        subscriberid: formData?.premDetails?.calixSubscriberIdToDelete || "NA",
        subscriberserviceid:
          formData?.premDetails?.calixSubscriberServiceIdToDelete || "NA",
        serviceReferenceNumber:
          formData?.premDetails?.smxSubscriberToDelete || "NA",
        oltId: formData?.premDetails?.deleteONT
          ? formData?.premDetails?.oltIdToDelete
          : "",
        ontId: formData?.premDetails?.deleteONT
          ? formData?.premDetails?.ontIdToDelete
          : "",
        deleteSubscriber: formData?.premDetails?.deleteSubscriber,
      }),
    );

    if (res?.payload?.data?.["is-success"]) {
      updateTaskStatus("delete_subscriber", "completed");
      return { success: true, message: "Subscriber deleted successfully" };
    } else {
      let message = "";
      if (res?.payload?.data?.["messages"]) {
        message += res?.payload?.data?.["messages"].join(", ");
      }
      const formattedMessage = formatErrorMessage(message);
      updateTaskStatus("delete_subscriber", "failed", formattedMessage);
      return { success: false, message: "Failed to delete subscriber" };
    }
  };

  const executeOrderUpdateSetFalse = async (caseClosed) => {
    updateTaskStatus("update_order_false", "processing");

    if (caseClosed) {
      updateTaskStatus("update_order_false", "skipped");
      return { success: true, message: "Order updated not required." };
    }

    const res = await dispatch(
      updateOrderDetails({
        order_number: formData?.premDetails?.orderNumber,
        invoke_provisioning: false,
        invok_billing: false,
      }),
    );

    if (res?.payload?.data?.["is-success"]) {
      updateTaskStatus("update_order_false", "completed");
      return { success: true, message: "Order updated successfully" };
    } else {
      let message = "";
      if (res?.payload?.data?.["messages"]) {
        message += res?.payload?.data?.["messages"].join(", ");
      }
      updateTaskStatus("update_order_false", "failed", message);
      return { success: false, message: "Failed to update order" };
    }
  };

  const executeOrderUpdate = async (caseClosed) => {
    updateTaskStatus("update_order_true", "processing");

    if (caseClosed) {
      updateTaskStatus("update_order_true", "skipped");
      return { success: true, message: "Order updated not required." };
    }

    const res = await dispatch(
      updateOrderDetails({
        order_number: formData?.premDetails?.orderNumber,
        invoke_provisioning: true,
        invok_billing: true,
      }),
    );

    if (res?.payload?.data?.["is-success"]) {
      updateTaskStatus("update_order_true", "completed");
      return { success: true, message: "Order updated successfully" };
    } else {
      let message = "";
      if (res?.payload?.data?.["messages"]) {
        message += res?.payload?.data?.["messages"].join(", ");
      }
      updateTaskStatus("update_order_true", "failed", message);
      return { success: false, message: "Failed to update order" };
    }
  };

  const executeNewSMXProvisioning = async () => {
    updateTaskStatus("new_provisioning", "processing");

    const res = await dispatch(
      createSubscriber({
        ...formData?.premDetails?.smxProvisioning,
        "device-data": {
          "create-new-ont": formData.premDetails.create_new_ont,
          ont: {
            "olt-id": formData.premDetails.olt_id,
            "ont-fsan-number": formData.premDetails.ont_fsan,
            "ont-id": formData.premDetails.ont_id,
            "ont-port-id": formData.premDetails.ont_port_id,
            "ont-profile-id": formData.premDetails.ont_profile_id,
            "ont-type": formData.premDetails.ont_type,
            "vlan-id": formData.premDetails.vlan_id,
          },
          router: {
            "router-fsan-number": formData.premDetails.rg_fsan,
          },
        },
        "service-address": {
          "address-line1": formData.premDetails.street_address,
          "address-line2": "",
          "city-name": formData.premDetails.city,
          "country-code": "US",
          "postal-code": formData.premDetails.zip,
          "state-code": formData.premDetails.state,
        },
        "service-reference-number": formData.premDetails.subscriberId,
      }),
    );

    if (res?.payload?.data?.["is-success"]) {
      updateTaskStatus("new_provisioning", "completed");
      return {
        success: true,
        message: "Provisioning completed successfully",
        subscriberId: res?.payload?.data?.data?.["subscriber-id"],
        subscriberServiceId:
          res?.payload?.data?.data?.["subscriber-service-id"],
      };
    } else {
      let message = "";
      if (res?.payload?.data?.["messages"]) {
        message += res?.payload?.data?.["messages"].join(", ");
      }
      const formattedMessage = formatErrorMessage(message);
      updateTaskStatus("new_provisioning", "failed", formattedMessage);
      return {
        success: false,
        message: "Provisioning Failed",
        subscriberId: res?.payload?.data?.data?.["subscriber-id"],
        subscriberServiceId:
          res?.payload?.data?.data?.["subscriber-service-id"],
      };
    }
  };

  const executeCaseClose = async () => {
    updateTaskStatus("close_case", "processing");

    const res = await dispatch(
      updateCaseDetails({
        case_number: formData?.premDetails?.caseNumber,
        status: "Closed",
      }),
    );

    if (res?.payload?.data?.["is-success"]) {
      updateTaskStatus("close_case", "completed");
      const isAlreadyClosed = res.payload.data.messages?.some((msg) =>
        msg.includes("Case is already closed"),
      );
      return {
        success: true,
        message: isAlreadyClosed
          ? "Case is already closed"
          : "Case closed successfully",
      };
    } else {
      let message = "";
      if (res?.payload?.data?.["messages"]) {
        message += res?.payload?.data?.["messages"].join(", ");
      }
      updateTaskStatus("close_case", "failed", message);
      return { success: false, message: "Failed to close case" };
    }
  };

  // Execute all tasks in sequence
  const executeAllTasks = async () => {
    setFormData((prev) => ({ ...prev, formSubmitting: true }));
    setShowTaskProgress(true);

    const results = [];

    // Execute service point update
    const servicePointResult = await executeServicePointUpdate();
    results.push(servicePointResult);

    // Execute subscriber deletion if needed
    if (
      formData?.premDetails?.deleteSubscriber ||
      formData?.premDetails?.deleteONT
    ) {
      const deleteResult = await executeSubscriberDeletion();
      results.push(deleteResult);
    }

    let caseClosed = false;
    // Execute case close if needed
    if (formData?.premDetails?.closeCase) {
      const caseResult = await executeCaseClose();
      results.push(caseResult);
      caseClosed =
        caseResult.success && caseResult.message === "Case closed successfully";
    }

    // Execute order update if needed
    if (
      formData?.premDetails?.resumeEnrollmentFlow &&
      !formData?.premDetails?.smxProvisioning?.selected
    ) {
      const orderResultFalse = await executeOrderUpdateSetFalse(caseClosed);
      results.push(orderResultFalse);

      const orderResult = await executeOrderUpdate(caseClosed);
      results.push(orderResult);
    }

    if (formData?.premDetails?.smxProvisioning?.selected) {
      const newProvisioningResult = await executeNewSMXProvisioning();
      results.push(newProvisioningResult);

      setFormData((prev) => ({
        ...prev,
        premDetails: {
          ...prev.premDetails,
          calixSubscriberId: newProvisioningResult.subscriberId,
          calixSubscriberServiceId: newProvisioningResult.subscriberServiceId,
        },
      }));

      if (newProvisioningResult.subscriberId) {
        const servicePointAgainResult = await executeServicePointUpdateAgain(
          newProvisioningResult,
        );
        results.push(servicePointAgainResult);
      } else {
        updateTaskStatus(
          "update_service_point_again",
          "failed",
          "Failed because of provisioning is failed.",
        );
      }
    }

    setFormData((prev) => ({ ...prev, formSubmitting: false }));

    // Show summary notification
    const allSuccessful = results.every((r) => r.success);
    const successCount = results.filter((r) => r.success).length;
    const totalCount = results.length;

    if (allSuccessful) {
      showNotification(
        `All tasks completed successfully (${successCount}/${totalCount})`,
        "success",
      );
    } else {
      showNotification(
        `Completed ${successCount}/${totalCount} tasks with errors`,
        "error",
      );
    }

    // Auto-hide task progress after 5 seconds if all successful
    if (allSuccessful) {
      setTimeout(() => {
        setShowTaskProgress(false);
        setTaskList([]);
      }, 5000);
    }
  };

  const fetchDetailsFromSalesForce = async () => {
    setFormData((prev) => ({
      ...prev,
      premDetails: {
        ...prev.premDetails,
        smxProvisioning: {
          ...prev.premDetails.smxProvisioning,
          fetchDetails: true,
        },
      },
    }));

    try {
      // First API call
      const smxOrderItemDetails = await dispatch(
        getSmxOrderItemDetails(formData.premDetails.orderNumber),
      );

      if (
        !smxOrderItemDetails?.payload?.data?.["is-success"] ||
        smxOrderItemDetails?.payload?.data?.data?.["totalSize"] < 1
      ) {
        showNotification(
          `Failed to fetch SMX Order Item Details for Order ${formData.premDetails.orderNumber}`,
          "error",
        );
        return;
      }

      const orderData = smxOrderItemDetails.payload.data.data.records[0];

      // Populate data from first call
      setFormData((prev) => ({
        ...prev,
        premDetails: {
          ...prev.premDetails,
          smxProvisioning: {
            ...prev.premDetails.smxProvisioning,
            region: orderData.vlocity_cmt__PremisesId__r?.ciG_Region__c,

            service: {
              "policy-map": "",
              "service-code": orderData.product2?.productCode,
              "service-status": "enabled",
              "service-template": "",
              "service-type-code": "DATA_SERVICE",
            },
            "service-start-date": dayjs(orderData.order?.effectiveDate).format(
              "MM-DD-YYYY",
            ),
            subscriber: {
              "billing-address": {
                "address-line1":
                  orderData.vlocity_cmt__BillingAccountId__r?.billingStreet,
                "address-line2": "",
                "city-name":
                  orderData.vlocity_cmt__BillingAccountId__r?.billingCity,
                "country-code": "US",
                "postal-code":
                  orderData.vlocity_cmt__BillingAccountId__r?.billingPostalCode,
                "state-code":
                  orderData.vlocity_cmt__BillingAccountId__r?.billingState,
              },
              "business-name": orderData.order?.account?.name,
              "customer-type-code": orderData.order?.account?.type,
              "email-id":
                orderData?.order?.account?.vlocity_cmt__PrimaryContactId__r
                  ?.email,
              "first-name":
                orderData?.order?.account?.vlocity_cmt__PrimaryContactId__r
                  ?.firstName,
              "last-name":
                orderData?.order?.account?.vlocity_cmt__PrimaryContactId__r
                  ?.lastName,
              "opt-out-of-marketing": true,
              "phone-number":
                orderData?.order?.account?.vlocity_cmt__PrimaryContactId__r
                  ?.phone,
              "preferred-language-code": "en_US",
            },
          },
        },
      }));

      // Second API call
      const smxTemplateMetaDataDetails = await dispatch(
        getSmxTemplateMetadata({
          productCode: orderData.product2?.productCode,
          ontTemplate: formData.premDetails.ont_profile_id,
        }),
      );

      if (
        !smxTemplateMetaDataDetails?.payload?.data?.["is-success"] ||
        smxTemplateMetaDataDetails?.payload?.data?.data?.["totalSize"] < 1
      ) {
        showNotification(
          "SMX Order Item Details fetched successfully, but Template Metadata fetch failed",
          "warning",
        );
        return;
      }

      const templateData =
        smxTemplateMetaDataDetails.payload.data.data.records[0];

      // Update with template data
      setFormData((prev) => ({
        ...prev,
        premDetails: {
          ...prev.premDetails,
          smxProvisioning: {
            ...prev.premDetails.smxProvisioning,
            service: {
              ...prev.premDetails.smxProvisioning.service,
              "policy-map": templateData?.ciG_Policy_Map__c,
              "service-template": templateData?.ciG_Service_Template__c,
            },
          },
        },
      }));

      showNotification(
        "SMX Order and Template Details Fetched Successfully",
        "success",
      );
    } catch (error) {
      showNotification("An error occurred while fetching SMX details", "error");
      console.error("Error fetching SMX details:", error);
    } finally {
      // Always reset fetchDetails flag
      setFormData((prev) => ({
        ...prev,
        premDetails: {
          ...prev.premDetails,
          smxProvisioning: {
            ...prev.premDetails.smxProvisioning,
            fetchDetails: false,
          },
        },
      }));
    }
  };

  // Main validation and submission handler
  const ValidateAndSubmit = async () => {
    // Step 1: Validate form
    const validationErrors = validateForm(
      formData?.premDetails,
      validationRules,
    );
    setErrorMessages(validationErrors);
    const hasNoErrors = Object.keys(validationErrors)?.length === 0;

    if (!hasNoErrors) {
      showNotification(
        "Please fix all validation errors before submitting",
        "error",
      );
      return;
    }

    // Step 2: Build task list
    const tasks = buildTaskList();
    setTaskList(tasks);

    // Step 4: Validate address match
    if (formData?.location && formData?.address && !validateAddressMatch()) {
      setConfirmationDialogs((prev) => ({ ...prev, addressMismatch: true }));
      return;
    }

    // Step 5: Check if subscriber deletion is needed
    if (
      formData?.premDetails?.deleteSubscriber ||
      formData?.premDetails?.deleteONT
    ) {
      setConfirmationDialogs((prev) => ({ ...prev, deleteSubscriber: true }));
      return;
    }

    // Step 6: Execute all tasks
    await executeAllTasks();
  };

  const handleAddressMismatchConfirm = () => {
    setConfirmationDialogs((prev) => ({ ...prev, addressMismatch: false }));

    // Continue with subscriber deletion check
    if (
      formData?.premDetails?.deleteSubscriber ||
      formData?.premDetails?.deleteONT
    ) {
      setConfirmationDialogs((prev) => ({ ...prev, deleteSubscriber: true }));
      return;
    }

    // Execute tasks
    executeAllTasks();
  };

  const handleDeleteSubscriberConfirm = () => {
    setConfirmationDialogs((prev) => ({ ...prev, deleteSubscriber: false }));

    // Execute tasks
    executeAllTasks();
  };

  // Dialog close handlers
  const closeAllDialogs = () => {
    setConfirmationDialogs({
      addressMismatch: false,
      deleteSubscriber: false,
    });
  };

  // Input change handler
  const handleInputChange = (path, value) => {
    setFormData((prev) => {
      const newData = { ...prev };
      const keys = path.split(".");
      let temp = newData;

      keys.slice(0, -1).forEach((key) => {
        if (!temp[key]) temp[key] = {};
        temp = temp[key];
      });

      temp[keys[keys.length - 1]] = value;
      return newData;
    });
  };

  const clearAddressList = () => {
    setSearchedAdrr([]);
  };

  // Get task status icon
  const getTaskStatusIcon = (status) => {
    switch (status) {
      case "completed":
        return "✓";
      case "processing":
        return <CircularProgress size={16} />;
      case "failed":
        return "✗";
      default:
        return "○";
    }
  };

  // Get task status color
  const getTaskStatusColor = (status) => {
    switch (status) {
      case "completed":
        return "#28a745";
      case "processing":
        return "#007bff";
      case "failed":
        return "#dc3545";
      default:
        return "#6c757d";
    }
  };

  return (
    <>
      {/* Confirmation Dialogs */}
      <ConfirmationDialog
        title="Address Mismatch Warning"
        open={confirmationDialogs.addressMismatch}
        onClose={() =>
          setConfirmationDialogs((prev) => ({
            ...prev,
            addressMismatch: false,
          }))
        }
        onConfirm={handleAddressMismatchConfirm}
        content={
          <h4 className="text-center">
            ONT FSAN address:
            <br />
            {formData.location}
            <br />
            Not matching with selected address.
            <br />
            Would you like to proceed?
          </h4>
        }
      />

      <ConfirmationDialog
        title="Confirm Deletion"
        open={confirmationDialogs.deleteSubscriber}
        onClose={() =>
          setConfirmationDialogs((prev) => ({
            ...prev,
            deleteSubscriber: false,
          }))
        }
        onConfirm={handleDeleteSubscriberConfirm}
        content={
          formData?.premDetails?.deleteSubscriber &&
          formData?.premDetails?.deleteONT
            ? `Are you sure you want to delete this Subscriber(${formData.premDetails.smxSubscriberToDelete}) and ONT(${formData.premDetails.ontIdToDelete})? This action cannot be undone.`
            : formData?.premDetails?.deleteSubscriber
              ? `Are you sure you want to delete this Subscriber(${formData.premDetails.smxSubscriberToDelete})? This action cannot be undone.`
              : formData?.premDetails?.deleteONT
                ? `Are you sure you want to delete this ONT(${formData.premDetails.ontIdToDelete})? This action cannot be undone.`
                : "Are you sure you want to proceed?"
        }
      />

      {/* Snackbar */}
      <CustomSnackbar
        openSnackbar={openSnackbar}
        severity={
          showMessage.includes("Failed") || showMessage.includes("Error")
            ? "error"
            : "success"
        }
        message={showMessage}
        autoHideDuration={3000}
        handleClose={() => setOpenSnackbar(false)}
      />

      <div className="row min-h-100">
        <div className="col-xxl-12">
          <div className="card card-custom card-xxl-stretch manage-fiber-service fiber-enrollment-issue">
            <div className="card-body">
              <div className="row justify-content-center">
                <div className="col-lg-10">
                  {/* Address Search */}
                  <div className="mb-3">
                    <div className="custom_title mb-3">
                      <h3 className="heading">
                        Please enter your address below
                      </h3>
                    </div>
                    <div className="custom_search_form">
                      <div className="custom_search">
                        <div className="custom_search_input">
                          <div className="custom_search_input_left">
                            <span>
                              <svg
                                width="18"
                                height="22"
                                viewBox="0 0 18 22"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M17.62 7.45C16.57 2.83 12.54 0.75 9 0.75C9 0.75 9 0.75 8.99 0.75C5.46 0.75 1.42 2.82 0.370004 7.44C-0.799996 12.6 2.36 16.97 5.22 19.72C6.28 20.74 7.64 21.25 9 21.25C10.36 21.25 11.72 20.74 12.77 19.72C15.63 16.97 18.79 12.61 17.62 7.45ZM9 12.46C7.26 12.46 5.85 11.05 5.85 9.31C5.85 7.57 7.26 6.16 9 6.16C10.74 6.16 12.15 7.57 12.15 9.31C12.15 11.05 10.74 12.46 9 12.46Z"
                                  fill="#767483"
                                />
                              </svg>
                            </span>
                            <Autocomplete
                              freeSolo
                              style={{ width: "100%", padding: "0px" }}
                              // value={formData || ""}
                              open={open}
                              onOpen={() => setOpen(true)}
                              onClose={() => setOpen(false)}
                              onInputChange={(event, value, reason) => {
                                setInputValue(value);
                                if (reason === "clear" || value === "") {
                                  clearAddressList();
                                }
                              }}
                              inputValue={inputValue}
                              onChange={(event, value) => {
                                if (value?.crm_premise_id) {
                                  setFormData({ ...formData, ...value });
                                }
                              }}
                              isOptionEqualToValue={(option, value) =>
                                option.crm_premise_id === value.crm_premise_id
                              }
                              getOptionLabel={(option) => {
                                return [
                                  option?.address || option?.street_address,
                                  option?.city,
                                  [option?.state, option?.zip]
                                    .filter(Boolean)
                                    .join(" "),
                                ]
                                  .filter(Boolean)
                                  .join(", ")
                                  .trim();
                              }}
                              options={searchedAddreess || []}
                              loading={searchLoader}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  onChange={(e) => updateAddress(e)}
                                  placeholder="Search Address"
                                  variant="standard"
                                  InputProps={{
                                    ...params.InputProps,
                                    disableUnderline: true,
                                    style: {
                                      border: "none",
                                      padding: 0,
                                      boxShadow: "none",
                                    },
                                    endAdornment: (
                                      <>
                                        {searchLoader && (
                                          <CircularProgress
                                            color="inherit"
                                            size={20}
                                          />
                                        )}
                                        {params.InputProps.endAdornment}
                                      </>
                                    ),
                                  }}
                                  sx={{
                                    "& .MuiInputBase-root": {
                                      border: "none",
                                      "&:hover": { border: "none" },
                                      "&.Mui-focused": { border: "none" },
                                    },
                                  }}
                                />
                              )}
                            />
                          </div>
                          <a href="">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M22 11.25H19.96C19.6 7.44 16.56 4.39 12.75 4.04V2C12.75 1.59 12.41 1.25 12 1.25C11.59 1.25 11.25 1.59 11.25 2V4.04C7.44 4.4 4.39 7.44 4.04 11.25H2C1.59 11.25 1.25 11.59 1.25 12C1.25 12.41 1.59 12.75 2 12.75H4.04C4.4 16.56 7.44 19.61 11.25 19.96V22C11.25 22.41 11.59 22.75 12 22.75C12.41 22.75 12.75 22.41 12.75 22V19.96C16.56 19.6 19.61 16.56 19.96 12.75H22C22.41 12.75 22.75 12.41 22.75 12C22.75 11.59 22.41 11.25 22 11.25ZM12 15.12C10.28 15.12 8.88 13.72 8.88 12C8.88 10.28 10.28 8.88 12 8.88C13.72 8.88 15.12 10.28 15.12 12C15.12 13.72 13.72 15.12 12 15.12Z"
                                fill="#767483"
                              />
                            </svg>
                          </a>
                        </div>

                        <button
                          disabled={
                            formData?.crm_premise_id === "" ||
                            formData?.premiseCalling
                          }
                          className="btn btn-custom startlit_navy"
                          onClick={() => LoadGridData()}
                        >
                          Search{" "}
                          {formData?.premiseCalling && (
                            <CircularProgress color="inherit" size={20} />
                          )}
                        </button>
                        <button
                          className="btn btn-custom outline-light"
                          style={{ height: 48, width: 100 }}
                          onClick={() => setFormData(initState)}
                        >
                          Clear
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Form Fields */}
                  <div>
                    <div className="row">
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label htmlFor="">
                            ONT FSAN <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData?.premDetails?.ont_fsan || ""}
                            onChange={(e) =>
                              handleInputChange(
                                "premDetails.ont_fsan",
                                e.target.value,
                              )
                            }
                          />
                          {errorMessages.ont_fsan && (
                            <div style={{ fontSize: "small", color: "red" }}>
                              {errorMessages.ont_fsan}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label htmlFor="">
                            ONT Port ID <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData?.premDetails?.ont_port_id || ""}
                            onChange={(e) =>
                              handleInputChange(
                                "premDetails.ont_port_id",
                                e.target.value,
                              )
                            }
                          />
                          {errorMessages.ont_port_id && (
                            <div style={{ fontSize: "small", color: "red" }}>
                              {errorMessages.ont_port_id}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label htmlFor="">
                            ONT Profile ID{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData?.premDetails?.ont_profile_id || ""}
                            onChange={(e) =>
                              handleInputChange(
                                "premDetails.ont_profile_id",
                                e.target.value,
                              )
                            }
                          />
                          {errorMessages.ont_profile_id && (
                            <div style={{ fontSize: "small", color: "red" }}>
                              {errorMessages.ont_profile_id}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label htmlFor="">
                            ONT ID <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData?.premDetails?.ont_id || ""}
                            onChange={(e) =>
                              handleInputChange(
                                "premDetails.ont_id",
                                e.target.value,
                              )
                            }
                          />
                          {errorMessages.ont_id && (
                            <div style={{ fontSize: "small", color: "red" }}>
                              {errorMessages.ont_id}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label htmlFor="">
                            ONT Type <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData?.premDetails?.ont_type || ""}
                            onChange={(e) =>
                              handleInputChange(
                                "premDetails.ont_type",
                                e.target.value,
                              )
                            }
                          />
                          {errorMessages.ont_type && (
                            <div style={{ fontSize: "small", color: "red" }}>
                              {errorMessages.ont_type}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label htmlFor="">
                            Router FSAN <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData?.premDetails?.rg_fsan || ""}
                            onChange={(e) =>
                              handleInputChange(
                                "premDetails.rg_fsan",
                                e.target.value,
                              )
                            }
                          />
                          {errorMessages.rg_fsan && (
                            <div style={{ fontSize: "small", color: "red" }}>
                              {errorMessages.rg_fsan}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label htmlFor="serviceStatus">
                            Service Status{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <select
                            id="serviceStatus"
                            className="form-control"
                            value={
                              formData?.premDetails?.service_status === true
                                ? "true"
                                : formData?.premDetails?.service_status ===
                                    false
                                  ? "false"
                                  : ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "premDetails.service_status",
                                e.target.value === "true",
                              )
                            }
                          >
                            <option value="">Select</option>
                            <option value="true">Active</option>
                            <option value="false">Inactive</option>
                          </select>
                          {errorMessages.service_status && (
                            <div style={{ fontSize: "small", color: "red" }}>
                              {errorMessages.service_status}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          <label htmlFor="">
                            New SMX Subscriber ID{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData?.premDetails?.subscriberId || ""}
                            onChange={(e) =>
                              handleInputChange(
                                "premDetails.subscriberId",
                                e.target.value,
                              )
                            }
                          />
                          <div style={{ fontSize: "small", color: "green" }}>
                            Service Reference Number
                          </div>
                          {errorMessages.subscriberId && (
                            <div style={{ fontSize: "small", color: "red" }}>
                              {errorMessages.subscriberId}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label htmlFor="">&nbsp;</label>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="create-ont-checkbox"
                              checked={formData?.premDetails?.create_new_ont}
                              onChange={(e) =>
                                handleInputChange(
                                  "premDetails.create_new_ont",
                                  e.target.checked,
                                )
                              }
                            />
                            <label
                              className="form-check-label fw-500"
                              htmlFor="create-ont-checkbox"
                            >
                              Create New ONT
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label htmlFor="">
                            App Service Name{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={
                              formData?.premDetails?.app_service_name || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "premDetails.app_service_name",
                                e.target.value,
                              )
                            }
                          />
                          {errorMessages.app_service_name && (
                            <div style={{ fontSize: "small", color: "red" }}>
                              {errorMessages.app_service_name}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label htmlFor="">
                            OLT ID <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData?.premDetails?.olt_id || ""}
                            onChange={(e) =>
                              handleInputChange(
                                "premDetails.olt_id",
                                e.target.value,
                              )
                            }
                          />
                          {errorMessages.olt_id && (
                            <div style={{ fontSize: "small", color: "red" }}>
                              {errorMessages.olt_id}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label htmlFor="">
                            VLAN ID <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={formData?.premDetails?.vlan_id || ""}
                            onChange={(e) =>
                              handleInputChange(
                                "premDetails.vlan_id",
                                e.target.value,
                              )
                            }
                          />
                          {errorMessages.vlan_id && (
                            <div style={{ fontSize: "small", color: "red" }}>
                              {errorMessages.vlan_id}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label htmlFor="">
                            New Calix Subscriber ID (Optional)
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={
                              formData?.premDetails?.calixSubscriberId || ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "premDetails.calixSubscriberId",
                                e.target.value,
                              )
                            }
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label htmlFor="">
                            New Calix Subscriber Service ID (Optional)
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={
                              formData?.premDetails?.calixSubscriberServiceId ||
                              ""
                            }
                            onChange={(e) =>
                              handleInputChange(
                                "premDetails.calixSubscriberServiceId",
                                e.target.value,
                              )
                            }
                          />
                        </div>
                      </div>
                    </div>

                    {/* Resume Enrollment Flow */}
                    <div
                      className="row border rounded mb-3 p-2"
                      style={{ alignItems: "center" }}
                    >
                      <div className="col-6">
                        {/* Default selected option */}
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="provisioningFlow"
                            id="data-update-flow"
                            checked={
                              !formData?.premDetails?.resumeEnrollmentFlow &&
                              !formData?.premDetails?.preProvisioning
                            }
                            onChange={() => {
                              handleInputChange(
                                "premDetails.resumeEnrollmentFlow",
                                false,
                              );
                              handleInputChange(
                                "premDetails.preProvisioning",
                                false,
                              );
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="data-update-flow"
                          >
                            Salesforce Updates Only
                          </label>
                        </div>

                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="provisioningFlow"
                            id="resume-enrollment-flow"
                            checked={
                              formData?.premDetails?.resumeEnrollmentFlow
                            }
                            onChange={(e) => {
                              handleInputChange(
                                "premDetails.resumeEnrollmentFlow",
                                e.target.checked,
                              );

                              if (e.target.checked) {
                                handleInputChange(
                                  "premDetails.preProvisioning",
                                  false,
                                );
                              }
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="resume-enrollment-flow"
                          >
                            Resume Enrollment in Salesforce (Order Number
                            Required)
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="provisioningFlow"
                            id="pre-provisioning-flow"
                            checked={formData?.premDetails?.preProvisioning}
                            onChange={(e) => {
                              handleInputChange(
                                "premDetails.preProvisioning",
                                e.target.checked,
                              );

                              if (e.target.checked) {
                                handleInputChange(
                                  "premDetails.resumeEnrollmentFlow",
                                  false,
                                );

                                handleInputChange(
                                  "premDetails.smxProvisioning.selected",
                                  true,
                                );

                                handleInputChange(
                                  "premDetails.smxProvisioning.subscriber.billing-address",
                                  {
                                    "address-line1":
                                      formData.premDetails.street_address,
                                    "address-line2": "",
                                    "city-name": formData.premDetails.city,
                                    "country-code": "US",
                                    "postal-code": formData.premDetails.zip,
                                    "state-code": formData.premDetails.state,
                                  },
                                );
                              }
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="pre-provisioning-flow"
                          >
                            Pre-Provisioning Flow
                          </label>
                        </div>
                      </div>
                      {formData?.premDetails?.resumeEnrollmentFlow && (
                        <div className="col-6">
                          <div className="form-group">
                            <label htmlFor="">
                              Order Number{" "}
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={formData?.premDetails?.orderNumber || ""}
                              onChange={(e) =>
                                handleInputChange(
                                  "premDetails.orderNumber",
                                  e.target.value,
                                )
                              }
                            />
                            {errorMessages.orderNumber && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {errorMessages.orderNumber}
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Close Case */}
                    <div
                      className="row border rounded mb-3 p-2"
                      style={{ alignItems: "center" }}
                    >
                      <div className="col-6">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="closeCase-checkbox"
                            checked={formData?.premDetails?.closeCase}
                            onChange={(e) =>
                              handleInputChange(
                                "premDetails.closeCase",
                                e.target.checked,
                              )
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor="closeCase-checkbox"
                          >
                            Close Case
                          </label>
                        </div>
                      </div>
                      {formData?.premDetails?.closeCase && (
                        <div className="col-6">
                          <div className="form-group">
                            <label htmlFor="">
                              Case Number{" "}
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={formData?.premDetails?.caseNumber || ""}
                              onChange={(e) =>
                                handleInputChange(
                                  "premDetails.caseNumber",
                                  e.target.value,
                                )
                              }
                            />
                            {errorMessages.caseNumber && (
                              <div style={{ fontSize: "small", color: "red" }}>
                                {errorMessages.caseNumber}
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Delete Subscriber */}
                    <div
                      className="row border rounded mb-3 p-2"
                      style={{ alignItems: "center" }}
                    >
                      <div className="col-6">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="delete-subscriber"
                            checked={formData?.premDetails?.deleteSubscriber}
                            onChange={(e) =>
                              handleInputChange(
                                "premDetails.deleteSubscriber",
                                e.target.checked,
                              )
                            }
                          />
                          <label
                            className="form-check-label text-danger"
                            htmlFor="delete-subscriber"
                          >
                            Delete Subscriber (SMX/Calix)
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="delete-ont"
                            checked={formData?.premDetails?.deleteONT}
                            onChange={(e) =>
                              handleInputChange(
                                "premDetails.deleteONT",
                                e.target.checked,
                              )
                            }
                          />
                          <label
                            className="form-check-label text-danger"
                            htmlFor="delete-ont"
                          >
                            Delete ONT (SMX/Calix)
                          </label>
                        </div>
                      </div>
                      {(formData?.premDetails?.deleteSubscriber ||
                        formData?.premDetails?.deleteONT) && (
                        <>
                          <div className="col-6">
                            <div className="form-group">
                              <label htmlFor="">
                                SMX Subscriber ID{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  formData?.premDetails
                                    ?.smxSubscriberToDelete || ""
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    "premDetails.smxSubscriberToDelete",
                                    e.target.value,
                                  )
                                }
                              />
                              {errorMessages.smxSubscriberToDelete && (
                                <div
                                  style={{ fontSize: "small", color: "red" }}
                                >
                                  {errorMessages.smxSubscriberToDelete}
                                </div>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                      {formData?.premDetails?.deleteSubscriber && (
                        <>
                          <div className="col-6">
                            <div className="form-group">
                              <label htmlFor="">
                                Calix Subscriber ID (Optional)
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  formData?.premDetails
                                    ?.calixSubscriberIdToDelete || ""
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    "premDetails.calixSubscriberIdToDelete",
                                    e.target.value,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="form-group">
                              <label htmlFor="">
                                Calix Subscriber Service ID (Optional)
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  formData?.premDetails
                                    ?.calixSubscriberServiceIdToDelete || ""
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    "premDetails.calixSubscriberServiceIdToDelete",
                                    e.target.value,
                                  )
                                }
                              />
                            </div>
                          </div>
                        </>
                      )}
                      {formData?.premDetails?.deleteONT && (
                        <>
                          <div className="col-6">
                            <div className="form-group">
                              <label htmlFor="">
                                ONT ID <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  formData?.premDetails?.ontIdToDelete || ""
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    "premDetails.ontIdToDelete",
                                    e.target.value,
                                  )
                                }
                              />
                              {errorMessages.ontIdToDelete && (
                                <div
                                  style={{ fontSize: "small", color: "red" }}
                                >
                                  {errorMessages.ontIdToDelete}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="form-group">
                              <label htmlFor="">
                                OLT ID <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  formData?.premDetails?.oltIdToDelete || ""
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    "premDetails.oltIdToDelete",
                                    e.target.value,
                                  )
                                }
                              />
                              {errorMessages.oltIdToDelete && (
                                <div
                                  style={{ fontSize: "small", color: "red" }}
                                >
                                  {errorMessages.oltIdToDelete}
                                </div>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                    </div>

                    {/* NEW Provisioning */}
                    <div
                      className="row border rounded mb-3 p-2"
                      style={{ alignItems: "center" }}
                    >
                      <div className="col-6">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="smxProvisioning-checkbox"
                            // disabled={
                            //   !formData?.premDetails.orderNumber &&
                            //   !formData.premDetails.ont_profile_id
                            // }
                            checked={
                              formData?.premDetails?.smxProvisioning.selected
                            }
                            onChange={(e) => {
                              handleInputChange(
                                "premDetails.smxProvisioning.selected",
                                e.target.checked,
                              );
                              if (!e.target.checked) {
                                handleInputChange(
                                  "premDetails.preProvisioning",
                                  false,
                                );
                              }
                            }}
                          />
                          <label
                            className="form-check-label text-success"
                            htmlFor="smxProvisioning-checkbox"
                          >
                            New Provisioning
                          </label>
                          {/* {!formData?.premDetails.orderNumber &&
                            !formData.premDetails.ont_profile_id && (
                              <span className="text-danger">
                                <br />
                                (Order Number and ONT Profile ID is required)
                              </span>
                            )} */}
                        </div>
                      </div>
                      {formData?.premDetails?.smxProvisioning.selected && (
                        <>
                          <div className="col-6">
                            {formData?.premDetails.orderNumber &&
                              formData?.premDetails?.resumeEnrollmentFlow && (
                                <div className="form-group">
                                  <button
                                    className="btn btn-custom startlit_navy px-5"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      fetchDetailsFromSalesForce();
                                    }}
                                    disabled={
                                      formData?.premDetails?.smxProvisioning
                                        .fetchDetails
                                    }
                                  >
                                    Fetch Details From Sales Force For Order (
                                    {formData?.premDetails.orderNumber})
                                    {formData?.premDetails.smxProvisioning
                                      .fetchDetails && (
                                      <CircularProgress
                                        color="inherit"
                                        size={20}
                                      />
                                    )}
                                  </button>
                                </div>
                              )}
                          </div>

                          {/* Service Fields */}
                          <div className="col-6">
                            <div className="form-group">
                              <label htmlFor="">
                                Policy Map{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  formData?.premDetails?.smxProvisioning
                                    .service["policy-map"] || ""
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    "premDetails.smxProvisioning.service.policy-map",
                                    e.target.value,
                                  )
                                }
                              />
                              {errorMessages[
                                "smxProvisioning.service.policy-map"
                              ] && (
                                <div
                                  style={{ fontSize: "small", color: "red" }}
                                >
                                  {
                                    errorMessages[
                                      "smxProvisioning.service.policy-map"
                                    ]
                                  }
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-6">
                            <div className="form-group">
                              <label htmlFor="">
                                Service Code{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  formData?.premDetails?.smxProvisioning
                                    .service["service-code"] || ""
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    "premDetails.smxProvisioning.service.service-code",
                                    e.target.value,
                                  )
                                }
                              />
                              {errorMessages[
                                "smxProvisioning.service.service-code"
                              ] && (
                                <div
                                  style={{ fontSize: "small", color: "red" }}
                                >
                                  {
                                    errorMessages[
                                      "smxProvisioning.service.service-code"
                                    ]
                                  }
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-6">
                            <div className="form-group">
                              <label htmlFor="">
                                Service Template{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  formData?.premDetails?.smxProvisioning
                                    .service["service-template"] || ""
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    "premDetails.smxProvisioning.service.service-template",
                                    e.target.value,
                                  )
                                }
                              />
                              {errorMessages[
                                "smxProvisioning.service.service-template"
                              ] && (
                                <div
                                  style={{ fontSize: "small", color: "red" }}
                                >
                                  {
                                    errorMessages[
                                      "smxProvisioning.service.service-template"
                                    ]
                                  }
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Service Start Date */}
                          <div className="col-6">
                            <div className="form-group">
                              <label htmlFor="">
                                Service Start Date{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="date"
                                className="form-control"
                                value={(() => {
                                  const dateStr =
                                    formData?.premDetails?.smxProvisioning[
                                      "service-start-date"
                                    ];
                                  if (dateStr) {
                                    const [month, day, year] =
                                      dateStr.split("-");
                                    return `${year}-${month}-${day}`; // Convert MM-dd-yyyy to yyyy-MM-dd
                                  }
                                  return "";
                                })()}
                                onChange={(e) => {
                                  const dateValue = e.target.value; // Format: yyyy-MM-dd
                                  if (dateValue) {
                                    const [year, month, day] =
                                      dateValue.split("-");
                                    const formattedDate = `${month}-${day}-${year}`; // MM-dd-yyyy
                                    handleInputChange(
                                      "premDetails.smxProvisioning.service-start-date",
                                      formattedDate,
                                    );
                                  } else {
                                    handleInputChange(
                                      "premDetails.smxProvisioning.service-start-date",
                                      "",
                                    );
                                  }
                                }}
                              />
                              {errorMessages[
                                "smxProvisioning.service-start-date"
                              ] && (
                                <div
                                  style={{ fontSize: "small", color: "red" }}
                                >
                                  {
                                    errorMessages[
                                      "smxProvisioning.service-start-date"
                                    ]
                                  }
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Subscriber Fields */}
                          <div className="col-12">
                            <h5 className="mt-3 mb-3">
                              Subscriber Information
                            </h5>
                          </div>

                          <div className="col-6">
                            <div className="form-group">
                              <label htmlFor="">
                                Business Name{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  formData?.premDetails?.smxProvisioning
                                    .subscriber["business-name"] || ""
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    "premDetails.smxProvisioning.subscriber.business-name",
                                    e.target.value,
                                  )
                                }
                              />
                              {errorMessages[
                                "smxProvisioning.subscriber.business-name"
                              ] && (
                                <div
                                  style={{ fontSize: "small", color: "red" }}
                                >
                                  {
                                    errorMessages[
                                      "smxProvisioning.subscriber.business-name"
                                    ]
                                  }
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-6">
                            <div className="form-group">
                              <label htmlFor="">
                                Customer Type Code{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  formData?.premDetails?.smxProvisioning
                                    .subscriber["customer-type-code"] || ""
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    "premDetails.smxProvisioning.subscriber.customer-type-code",
                                    e.target.value,
                                  )
                                }
                              />
                              {errorMessages[
                                "smxProvisioning.subscriber.customer-type-code"
                              ] && (
                                <div
                                  style={{ fontSize: "small", color: "red" }}
                                >
                                  {
                                    errorMessages[
                                      "smxProvisioning.subscriber.customer-type-code"
                                    ]
                                  }
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-6">
                            <div className="form-group">
                              <label htmlFor="">
                                First Name{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  formData?.premDetails?.smxProvisioning
                                    .subscriber["first-name"] || ""
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    "premDetails.smxProvisioning.subscriber.first-name",
                                    e.target.value,
                                  )
                                }
                              />
                              {errorMessages[
                                "smxProvisioning.subscriber.first-name"
                              ] && (
                                <div
                                  style={{ fontSize: "small", color: "red" }}
                                >
                                  {
                                    errorMessages[
                                      "smxProvisioning.subscriber.first-name"
                                    ]
                                  }
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-6">
                            <div className="form-group">
                              <label htmlFor="">
                                Last Name{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  formData?.premDetails?.smxProvisioning
                                    .subscriber["last-name"] || ""
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    "premDetails.smxProvisioning.subscriber.last-name",
                                    e.target.value,
                                  )
                                }
                              />
                              {errorMessages[
                                "smxProvisioning.subscriber.last-name"
                              ] && (
                                <div
                                  style={{ fontSize: "small", color: "red" }}
                                >
                                  {
                                    errorMessages[
                                      "smxProvisioning.subscriber.last-name"
                                    ]
                                  }
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-6">
                            <div className="form-group">
                              <label htmlFor="">
                                Email ID <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="email"
                                className="form-control"
                                value={
                                  formData?.premDetails?.smxProvisioning
                                    .subscriber["email-id"] || ""
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    "premDetails.smxProvisioning.subscriber.email-id",
                                    e.target.value,
                                  )
                                }
                              />
                              {errorMessages[
                                "smxProvisioning.subscriber.email-id"
                              ] && (
                                <div
                                  style={{ fontSize: "small", color: "red" }}
                                >
                                  {
                                    errorMessages[
                                      "smxProvisioning.subscriber.email-id"
                                    ]
                                  }
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-6">
                            <div className="form-group">
                              <label htmlFor="">
                                Phone Number{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="tel"
                                className="form-control"
                                value={
                                  formData?.premDetails?.smxProvisioning
                                    .subscriber["phone-number"] || ""
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    "premDetails.smxProvisioning.subscriber.phone-number",
                                    e.target.value,
                                  )
                                }
                              />
                              {errorMessages[
                                "smxProvisioning.subscriber.phone-number"
                              ] && (
                                <div
                                  style={{ fontSize: "small", color: "red" }}
                                >
                                  {
                                    errorMessages[
                                      "smxProvisioning.subscriber.phone-number"
                                    ]
                                  }
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Billing Address */}
                          <div className="col-12">
                            <h5 className="mt-3 mb-3">Billing Address</h5>
                          </div>

                          <div className="col-6">
                            <div className="form-group">
                              <label htmlFor="">
                                Address Line 1{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  formData?.premDetails?.smxProvisioning
                                    .subscriber["billing-address"][
                                    "address-line1"
                                  ] || ""
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    "premDetails.smxProvisioning.subscriber.billing-address.address-line1",
                                    e.target.value,
                                  )
                                }
                              />
                              {errorMessages[
                                "smxProvisioning.subscriber.billing-address.address-line1"
                              ] && (
                                <div
                                  style={{ fontSize: "small", color: "red" }}
                                >
                                  {
                                    errorMessages[
                                      "smxProvisioning.subscriber.billing-address.address-line1"
                                    ]
                                  }
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-6">
                            <div className="form-group">
                              <label htmlFor="">
                                City Name{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  formData?.premDetails?.smxProvisioning
                                    .subscriber["billing-address"][
                                    "city-name"
                                  ] || ""
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    "premDetails.smxProvisioning.subscriber.billing-address.city-name",
                                    e.target.value,
                                  )
                                }
                              />
                              {errorMessages[
                                "smxProvisioning.subscriber.billing-address.city-name"
                              ] && (
                                <div
                                  style={{ fontSize: "small", color: "red" }}
                                >
                                  {
                                    errorMessages[
                                      "smxProvisioning.subscriber.billing-address.city-name"
                                    ]
                                  }
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-6">
                            <div className="form-group">
                              <label htmlFor="">
                                State Code{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  formData?.premDetails?.smxProvisioning
                                    .subscriber["billing-address"][
                                    "state-code"
                                  ] || ""
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    "premDetails.smxProvisioning.subscriber.billing-address.state-code",
                                    e.target.value,
                                  )
                                }
                              />
                              {errorMessages[
                                "smxProvisioning.subscriber.billing-address.state-code"
                              ] && (
                                <div
                                  style={{ fontSize: "small", color: "red" }}
                                >
                                  {
                                    errorMessages[
                                      "smxProvisioning.subscriber.billing-address.state-code"
                                    ]
                                  }
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-6">
                            <div className="form-group">
                              <label htmlFor="">
                                Postal Code{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  formData?.premDetails?.smxProvisioning
                                    .subscriber["billing-address"][
                                    "postal-code"
                                  ] || ""
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    "premDetails.smxProvisioning.subscriber.billing-address.postal-code",
                                    e.target.value,
                                  )
                                }
                              />
                              {errorMessages[
                                "smxProvisioning.subscriber.billing-address.postal-code"
                              ] && (
                                <div
                                  style={{ fontSize: "small", color: "red" }}
                                >
                                  {
                                    errorMessages[
                                      "smxProvisioning.subscriber.billing-address.postal-code"
                                    ]
                                  }
                                </div>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer with Submit Button */}
            <div className="card-footer border-0">
              <div className="row justify-content-center">
                <div className="col-lg-10">
                  {/* Task Progress Display */}
                  {showTaskProgress && taskList.length > 0 && (
                    <div className="mb-4 p-3 border rounded bg-light">
                      <h5 className="mb-3">Task Progress</h5>
                      <div className="task-list">
                        {taskList.map((task) => (
                          <div
                            key={task.id}
                            className="d-flex align-items-center mb-2"
                            style={{
                              padding: "8px",
                              borderLeft: `4px solid ${getTaskStatusColor(
                                task.status,
                              )}`,
                              backgroundColor: "#fff",
                            }}
                          >
                            <span
                              style={{
                                marginRight: "10px",
                                color: getTaskStatusColor(task.status),
                                fontWeight: "bold",
                                minWidth: "20px",
                              }}
                            >
                              {getTaskStatusIcon(task.status)}
                            </span>
                            <span style={{ flex: 1, whiteSpace: "pre-line" }}>
                              {task.name}
                              <br />
                              {task.message}
                            </span>
                            <span
                              style={{
                                fontSize: "12px",
                                color: getTaskStatusColor(task.status),
                                textTransform: "capitalize",
                              }}
                            >
                              {task.status}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  <button
                    className="btn btn-custom startlit_navy px-5"
                    onClick={(e) => {
                      e.preventDefault();
                      ValidateAndSubmit();
                    }}
                    disabled={formData?.formSubmitting}
                  >
                    Submit
                    {formData?.formSubmitting && (
                      <CircularProgress color="inherit" size={20} />
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouteAccessCheck(FiberEnrollmentIssue);
